import React, { useState } from 'react';
import { Box, useMediaQuery, Theme, Drawer, IconButton } from '@mui/material';
import { useLocation, Outlet } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
// import Header from './Header';
import Sidebar from './Sidebar';
import ConsentModal from '../ConsentModal';
// import ConsentBanner from '../ConsentBanner';
import { useAuth } from '../../contexts/AuthContext';

const MainLayout: React.FC = () => {
  const location = useLocation();
  const { currentUser } = useAuth();
  const isLoginPage = location.pathname === '/login' || 
                     location.pathname === '/signup' || 
                     location.pathname === '/forgot-password' ||
                     location.pathname === '/confirm-email' ||
                     location.pathname === '/approve-user' ||
                     location.pathname === '/reset-password';
  
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);
  
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  
  // Don't show sidebar on auth pages
  if (isLoginPage) {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh',
        backgroundColor: 'background.default'
      }}>
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Outlet />
        </Box>
      </Box>
    );
  }
  
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'row', 
      minHeight: '100vh'
    }}>
      {/* Mobile drawer toggle */}
      {isMobile && (
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ position: 'fixed', top: 10, left: 10, zIndex: 1201 }}
        >
          <MenuIcon />
        </IconButton>
      )}
      
      {/* Mobile drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { 
            boxSizing: 'border-box', 
            width: 240,
            backgroundColor: '#0e1117',
            borderRight: '1px solid rgba(255, 255, 255, 0.08)'
          },
        }}
      >
        <Sidebar />
      </Drawer>
      
      {/* Desktop sidebar */}
      <Box
        component="nav"
        sx={{ width: { md: 240 }, flexShrink: { md: 0 } }}
      >
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', md: 'block' },
            '& .MuiDrawer-paper': { 
              boxSizing: 'border-box', 
              width: 240,
              backgroundColor: '#0e1117',
              borderRight: '1px solid rgba(255, 255, 255, 0.08)'
            },
          }}
          open
        >
          <Sidebar />
        </Drawer>
      </Box>
      
      {/* Main content */}
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        flexGrow: 1,
        overflow: 'auto',
        backgroundColor: 'background.default'
      }}>
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Outlet />
        </Box>
      </Box>

      {/* Consent Modal */}
      <ConsentModal
        open={currentUser ? !currentUser.consent_viewed : false}
        onClose={() => {}}
      />
    </Box>
  );
};

export default MainLayout;
